document.addEventListener("DOMContentLoaded", () => {
  setTimeout(function () {
    const productJson = [...document.querySelectorAll("[id^=ProductJson-")];
    if (productJson.length > 0) {
      productJson.forEach((product) => {
        const sectionId = product.id.replace(
          "ProductJson-",
          "shopify-section-"
        );
        const variantSKU = document.querySelector(
          "#" + sectionId + " .variant-sku"
        );
        const inputSelects = [
          ...document.querySelectorAll(
            "#" + sectionId + " [data-single-option-selector]"
          ),
        ];
        const productInfo = JSON.parse(product.innerHTML);

        inputSelects.forEach((input) => {
          input.addEventListener("change", (evt) => {
            // Just combine checked values and it can be compared against variant options
            const checkedInputSelects = [
              ...document.querySelectorAll(
                "#" + sectionId + " [data-single-option-selector]:checked"
              ),
            ];
            const checkedValues = checkedInputSelects.map((item) => item.value);

            productInfo.variants.forEach((variant) => {
              if (
                JSON.stringify(variant.options) == JSON.stringify(checkedValues)
              ) {
                variantSKU.innerText = "SKU: " + variant.sku;
              }
            });
          });
        });
      });
    }
  }, 100);
});